import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { DsCheckbox, TermsLabel } from "../../../common/inputs/DsCheckbox";
import { useReservationResources } from "../../../pageComponents/reservationPage/hooks/useReservationResources";
import { sanitizeWithNewTabLinks } from "../../../utils/Utils";
import { MerchantTerm } from "../../../types/reservation";
import { CheckboxGroup } from "../../../pageComponents/reservation-shared-styles";

interface AgreementCheckboxesProps {
  merchantTerms: MerchantTerm[];
  producerName: string;
}

export function AgreementCheckboxes({
  merchantTerms,
  producerName,
}: AgreementCheckboxesProps) {
  const { control, trigger, clearErrors, formState: { errors } } = useFormContext();
  const r = useReservationResources();

  return (
    <CheckboxGroup role="group" aria-label="Agreement options">
      {merchantTerms.map((term) => (
        <Controller
          key={term.termsId}
          control={control}
          name={`merchantTerms.${term.termsId}` as any}
          render={({ field, fieldState }) => (
            <DsCheckbox
              label={
                <span
                  dangerouslySetInnerHTML={{
                    __html: sanitizeWithNewTabLinks(term.label),
                  }}
                />
              }
              checked={!!field.value}
              onChange={(checked) => {
                field.onChange(checked);
                if (checked) trigger(`merchantTerms.${term.termsId}` as any);
                else clearErrors(`merchantTerms.${term.termsId}` as any);
              }}
              required={term.isMandatory}
              error={!!fieldState.error}
              helperText={fieldState.error ? r.TermsRequired : undefined}
            />
          )}
        />
      ))}
      <Controller
        control={control}
        name="receiveUpdates"
        render={({ field }) => (
          <DsCheckbox
            label={`${r.UpdatesCheckbox} ${producerName}.`}
            checked={field.value}
            onChange={field.onChange}
            required={false}
          />
        )}
      />
      <Controller
        control={control}
        name="acceptTerms"
        render={({ field }) => (
          <DsCheckbox
            id="accept-terms-checkbox"
            label={<TermsLabel />}
            checked={field.value}
            onChange={(checked) => {
              field.onChange(checked);
              if (checked) trigger("acceptTerms");
              else clearErrors("acceptTerms");
            }}
            required={true}
            error={!!(errors as any).acceptTerms}
            helperText={(errors as any).acceptTerms ? r.TermsRequired : undefined}
          />
        )}
      />
    </CheckboxGroup>
  );
}
